export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      role: 'Fashion Boutique Owner',
      avatar: 'https://public.readdy.ai/ai/img_res/390555ae09a52be2676e2a697aa5d103.jpg',
      content: 'MetaMind has completely transformed how I run my online boutique. The AI analytics help me understand what my customers want before they even search for it. Sales have increased by 240% in just six months!',
      rating: 5
    },
    {
      name: 'James Chen',
      role: 'Electronics Retailer',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20businessman%20in%20his%2040s%20with%20confident%20smile%2C%20wearing%20modern%20business%20casual%20attire%2C%20studio%20portrait%20with%20soft%20lighting%20on%20clean%20white%20background%2C%20professional%20and%20trustworthy%20appearance&width=200&height=200&seq=avatar-002&orientation=squarish',
      content: 'The automated fulfillment management is a game-changer. I can focus on growing my business while the platform handles logistics seamlessly. Customer satisfaction has never been higher.',
      rating: 5
    },
    {
      name: 'Emily Rodriguez',
      role: 'Home Decor Enthusiast',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Hispanic%20woman%20in%20her%2020s%20with%20bright%20smile%2C%20wearing%20casual%20modern%20clothing%2C%20studio%20portrait%20with%20soft%20lighting%20on%20clean%20white%20background%2C%20friendly%20and%20approachable%20demeanor&width=200&height=200&seq=avatar-003&orientation=squarish',
      content: 'As a customer, I love how the AI recommendations actually understand my style. I\'ve discovered so many amazing products I wouldn\'t have found otherwise. The shopping experience is incredibly personalized!',
      rating: 5
    },
    {
      name: 'Michael Thompson',
      role: 'Fitness Equipment Supplier',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20athletic%20man%20in%20his%2030s%20with%20confident%20smile%2C%20wearing%20sports%20casual%20attire%2C%20studio%20portrait%20with%20soft%20lighting%20on%20clean%20white%20background%2C%20energetic%20and%20positive%20expression&width=200&height=200&seq=avatar-004&orientation=squarish',
      content: 'The predictive analytics helped me optimize my inventory perfectly. No more overstocking or running out of popular items. The platform pays for itself with the efficiency gains alone.',
      rating: 5
    },
    {
      name: 'Lisa Anderson',
      role: 'Beauty Products Seller',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20elegant%20woman%20in%20her%2030s%20with%20warm%20smile%2C%20wearing%20professional%20makeup%20and%20stylish%20outfit%2C%20studio%20portrait%20with%20soft%20lighting%20on%20clean%20white%20background%2C%20polished%20and%20sophisticated%20appearance&width=200&height=200&seq=avatar-005&orientation=squarish',
      content: 'The 24/7 AI customer support handles most queries instantly, and my customers love the quick responses. It\'s like having a full support team without the overhead costs.',
      rating: 5
    },
    {
      name: 'David Park',
      role: 'Tech Gadgets Enthusiast',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20in%20his%2020s%20with%20friendly%20smile%2C%20wearing%20modern%20casual%20tech%20style%20clothing%2C%20studio%20portrait%20with%20soft%20lighting%20on%20clean%20white%20background%2C%20tech-savvy%20and%20innovative%20appearance&width=200&height=200&seq=avatar-006&orientation=squarish',
      content: 'The visual search feature is incredible! I can take a photo of something I like and find similar products instantly. This platform truly understands modern shopping behavior.',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-indigo-50 px-4 py-2 rounded-full mb-4">
            <i className="ri-chat-quote-line text-indigo-600"></i>
            <span className="text-sm font-semibold text-indigo-600">TESTIMONIALS</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Loved by Thousands of Users
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our community of buyers and sellers have to say about their experience with MetaMind.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="flex items-center space-x-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>
              <div className="flex items-center space-x-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover"
                />
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 bg-white rounded-2xl px-8 py-6 shadow-lg">
            <div className="text-center">
              <div className="text-3xl font-bold text-indigo-600">4.9/5</div>
              <div className="text-sm text-gray-600">Average Rating</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-indigo-600">50K+</div>
              <div className="text-sm text-gray-600">Reviews</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-indigo-600">98%</div>
              <div className="text-sm text-gray-600">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
